module.exports = __webpack_public_path__ + "img/gntech_gallery7.fc78f284.jpg";